/* ============================================================
   CLEVER CARAT — Global Brand JS
   Scroll-triggered fade-up animation via IntersectionObserver.
   Loaded once via theme.liquid snippet.
   ============================================================ */

(function () {
  'use strict';

  function initFadeUp() {
    var els = document.querySelectorAll('.cc-fade-up');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function (el) { observer.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFadeUp);
  } else {
    initFadeUp();
  }

  /* Re-run after Shopify section render events (theme editor) */
  document.addEventListener('shopify:section:load', function () {
    setTimeout(initFadeUp, 100);
  });
})();
